import config, { AppType } from "../config";

const isPostnup = config.appType === AppType.POSTNUP;

// ─── Core brand names ────────────────────────────────────────────────
export const BRAND_NAME = isPostnup ? "Postnup.com" : "HelloPrenup";
export const BRAND_LEGAL_ENTITY = isPostnup
  ? "Postnup.com, Inc."
  : "Hello Prenup, Inc.";

// ─── Document type labels ────────────────────────────────────────────
export const DOCUMENT_TYPE = isPostnup ? "postnup" : "prenup";
export const DOCUMENT_TYPE_FULL = isPostnup
  ? "postnuptial agreement"
  : "prenuptial agreement";
export const DOCUMENT_TYPE_CAPITALIZED = isPostnup ? "Postnup" : "Prenup";
export const DOCUMENT_TYPE_FULL_CAPITALIZED = isPostnup
  ? "Postnuptial Agreement"
  : "Prenuptial Agreement";
export const PREMARITAL_OR_POSTMARITAL = isPostnup
  ? "postmarital"
  : "premarital";

export const PARTNER_NAME = isPostnup ? "spouse" : "fiancé";
export const PARTNER_NAME_CAPITALIZED = isPostnup ? "Spouse" : "Fiancé";

// ─── URLs ────────────────────────────────────────────────────────────
// TODO: Replace postnup.com links with actual postnup.com URLs once available
export const BRAND_DOMAIN = isPostnup ? "postnup.com" : "helloprenup.com";
export const APP_DOMAIN = isPostnup ? "app.postnup.com" : "app.helloprenup.com";
export const TERMS_URL = isPostnup
  ? "https://postnup.com/terms-of-use/" // TODO: confirm postnup.com terms URL
  : "https://helloprenup.com/terms-of-use/";
export const PRIVACY_URL = isPostnup
  ? "https://postnup.com/privacy-policy/" // TODO: confirm postnup.com privacy URL
  : "https://helloprenup.com/privacy-policy/";
export const HELP_URL = isPostnup
  ? "https://help.postnup.com/en/" // TODO: confirm postnup.com help URL
  : "https://help.helloprenup.com/en/";
export const SUPPORT_EMAIL = isPostnup
  ? "support@postnup.com" // TODO: confirm postnup.com support email
  : "support@helloprenup.com";
export const NOTARY_INFO_URL = isPostnup
  ? "https://postnup.com/notary/" // TODO: confirm postnup.com notary URL
  : "https://helloprenup.com/notary/";

// ─── Profile ─────────────────────────────────────────────────────────
export const COUNTDOWN_LABEL = isPostnup
  ? "Countdown to 2 Year Anniversary"
  : 'Countdown to "I Do"';

// ─── Helper ──────────────────────────────────────────────────────────
export { isPostnup };
